import './index.scss'
import Rails from '@rails/ujs'
import I18n from '../../../javascript/i18n/index.js.erb'
import { Controller as BaseController } from 'stimulus'
import 'custom-event-polyfill'
import { flashError } from '@app/javascript/classes/flashMessages'

export class Controller extends BaseController {
  static targets = ['self', 'files', 'submitButton', 'spinnerButton', 'cancelButton']
  static classes = ['editing']

  connect() {
    const loaded = this.data.get('loaded')
    if (loaded === 'true') return

    this.filesTarget.innerHTML = `<h2>${I18n.t('template.files.loading')}</h2>`

    this.fetchFiles()
  }

  edit(event) {
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass)
    this.selfTarget.classList.add(this.editingClass)
  }

  cancel() {
    this.fetchFiles()
  }

  disableSave() {
    this.submitButtonTarget.disabled = true
  }

  enableSave() {
    this.submitButtonTarget.disabled = false
  }

  static values = {
    submitSent: Boolean,
    hiddenInputName: String
  }

  save(e) {
    if (this.submitSentValue === false) {
      this.submitSentValue = true
      e.preventDefault()
      const event = new CustomEvent('submitTriggered', { cancelable: true })
      window.dispatchEvent(event)
      this.submitButtonTarget.classList.add('hidden')
      this.cancelButtonTarget.classList.add('hidden')
      this.spinnerButtonTarget.classList.remove('hidden')
    }
  }

  finalizeSubmit(e) {
    e.detail.files_ids.forEach(id => {
      this.form().appendChild(this.createHiddenInput(id))
    })

    Rails.fire(this.form(), 'submit')
  }

  uploadFailed(_e) {
    flashError(I18n.t('entities.files.save.upload_error'))
    this.enableSave()
    this.submitSentValue = false
    this.submitButtonTarget.classList.remove('hidden')
    this.cancelButtonTarget.classList.remove('hidden')
    this.spinnerButtonTarget.classList.add('hidden')
  }

  form() {
    return this.submitButtonTarget.closest('form')
  }

  createHiddenInput(id) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = this.hiddenInputNameValue
    input.value = id
    return input
  }

  fetchFiles() {
    Rails.ajax({
      type: 'GET',
      dataType: 'script',
      url: this.data.get('url'),
      data: $.param({
        files_element_id: this.selfTarget.id
      }),
      error: () => {
        this.selfTarget.innerHTML = `<h2>${I18n.t('template.files.load_failure')}</h2>`
      }
    })
  }
}
